import { useMediaQuery } from "react-responsive";
import "../../styles/Offerings/AdditionalService.css";

const AdditionalService = ({ data }) => {
  const isDesktop = useMediaQuery({ minWidth: 786 });
  return (
    <div className="additionalComponentContainer">
      <div>
        <img
          className="additionalComponentContainerImg"
          src={data?.src}
          alt="icon"
          height={52}
          width={52}
        />
      </div>
      <div className="additionalComponentContainerTitle">{data?.title}</div>
      <div className="additionalComponentContainerDesc">
        {isDesktop ? data?.desc : `(${data?.desc})`}</div>
    </div>
  );
};

export default AdditionalService;
